import scales from "../foundations/scales";
const sizes = {
    'size.xs': scales[1],
    'size.s': scales[1.5],
    'size.m': scales[2],
    'size.l': scales[2.5],
    'size.xl': scales[3],
    'size.2xl': scales[4],
    'size.3xl': scales[8],
    'size.4xl': scales[16]
};
export default sizes;

//# sourceMappingURL=sizes.js.map